import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ModalController, NavController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { first } from 'rxjs/operators';

import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import { ConfigService } from 'src/app/provider/config.service';
import { Events } from 'src/app/provider/events.service';
import { AuthService } from 'src/app/services/auth.service';
import { AddAddressPage } from '../add-address/add-address.page';
import { EditAddressPage } from '../edit-address/edit-address.page';

@Component({
    selector: 'app-address-default',
    templateUrl: './address-default.page.html',
    styleUrls: ['./address-default.page.scss'],
})
export class AddressDefaultPage implements OnInit {
    settings: any = {}; loader: boolean = true;
    addressList: any = [];
    customer: any; selectedDate: any;
    addressId: number; addressName: string;
    activeSubscription: boolean = false; customerSubscriptionId: any;

    constructor(
        private events: Events,
        private navCtrl: NavController,
        private alertCtrl: AlertController,
        private toastCtrl: ToastController,
        private modalCtrl: ModalController,
        private translate: TranslateService,
        private authService: AuthService,
        private apiService: ApiService,
        private configService: ConfigService
    ) {
        this.customer = this.authService.getAuthUser();
        console.log(this.customer);
    }
    ngOnInit() {
        this.apiAddressCaller();
    }
    apiAddressCaller = () => {
        this.loader = true;
        this.addressList = [];
        this.apiService
            .get(endpoints.addresses + '?customer_id=' + this.customer.id)
            .pipe(first())
            .subscribe((response) => {
                console.log(response);
                this.loader = false;
                if (response.success) {
                    this.addressList = response.data.addresses;
                    console.log(this.addressList);
                } else if (response.code == 401) {
                    this.events.publish('user:login', { user: null, time: new Date() });
                }
            });
    }
    onDelete = async (aid: string) => {
        await this.alertCtrl.create({
            header: this.translate.instant('are_you_sure_want_to_delete'),
            buttons: [
                {
                    text: this.translate.instant('cancel'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('ok'),
                    role: 'confirm',
                    handler: () => {
                        this.apiService
                            .delete(endpoints.addresses + '/' + aid + '?customer_id=' + this.customer.id)
                            .pipe(first())
                            .subscribe((response) => {
                                console.log(response);
                                if (response.success) {
                                    this.apiAddressCaller();
                                    this.toastMessage(response.message);
                                } else if (response.code == 401) {
                                    this.events.publish('user:login', { user: null, time: new Date() });
                                }
                            });
                    }
                }
            ]
        }).then(alertElm => alertElm.present());
    }
    setDefault = async (aid: string) => {
        console.log(aid);
        this.apiService
            .get(endpoints.addresses + '/set/default?customer_id=' + this.customer.id + '&address_id=' + aid)
            .pipe(first())
            .subscribe((response) => {
                console.log(response);
                if (response.success) {
                    this.apiAddressCaller();
                    this.toastMessage(response.message);
                } else if (response.code == 401) {
                    this.events.publish('user:login', { user: null, time: new Date() });
                }
            });
    }
    updateAddress = () => {
        this.modalCtrl.dismiss({ data: true }, 'close');
    }
    closeModal = () => {
        this.modalCtrl.dismiss(null, 'cancel');
    }
    toastMessage = async (msg) => {
        await this.toastCtrl.create({
            message: this.translate.instant(msg),
            duration: 4000,
            position: 'top',
            color: 'primary'
        }).then((toastElem) => toastElem.present());
    }
}
